module.exports = __webpack_public_path__ + "img/gift@2x.5c0278d2.png";